import { render, staticRenderFns } from "./OrgaoForm.vue?vue&type=template&id=e43ab392&scoped=true&lang=pug&"
import script from "./OrgaoForm.vue?vue&type=script&lang=js&"
export * from "./OrgaoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43ab392",
  null
  
)

export default component.exports